// src/directives/trimEmail.js
export default {
	mounted(el) {
		applyUppercase(el)
	},
	updated(el) {
		applyUppercase(el)
	},
}

function applyUppercase(el) {
	const input = el.tagName === 'INPUT' ? el : el.querySelector('input')
	if (!input) return
    
    input.addEventListener('input', () => {
        const upper = input.value.toUpperCase()
        if (input.value !== upper) {
            input.value = upper
            input.dispatchEvent(new Event('input'))
        }
	})

	input.addEventListener('blur', () => {
		input.value = input.value.toUpperCase()
        input.dispatchEvent(new Event('input'))
	})
}
